import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/shop/ProtectedRoute";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState({ status: "checking" });
  const tries = useRef(0);

  useEffect(() => {
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState({ ...data, status: "paid" });
        if (data.status === "expired") return setState({ ...data, status: "failed" });
      } catch {}
      if (++tries.current >= 8) return setState((s) => ({ ...s, status: "timeout" }));
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);

  if (state.status === "checking") return <div className="py-20 text-center"><Loader /><p className="text-stone-600">Verifica del pagamento in corso...</p></div>;
  const ok = state.status === "paid";
  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="payment-result">
      {ok ? <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-600" /> : <XCircle className="mx-auto h-16 w-16 text-amber-600" />}
      <h1 className="mt-6 font-display text-4xl font-bold" data-testid="payment-result-title">{ok ? "Pagamento completato!" : "Pagamento non confermato"}</h1>
      <p className="mt-3 text-stone-600">
        {ok ? `Grazie! L'ordine ${state.order_number} è stato pagato e lo stiamo preparando.` : "Non abbiamo ancora ricevuto la conferma. Controlla lo stato nei tuoi ordini."}
      </p>
      <div className="mt-8 flex justify-center gap-3">
        {state.order_id && <Link to={`/ordine/${state.order_id}${state.order_token ? `?t=${state.order_token}` : ""}`} data-testid="payment-view-order" className="rounded-full bg-amber-500 px-6 py-3 font-bold text-black">Vedi ordine</Link>}
        <Link to="/catalogo" className="rounded-full border border-black/15 px-6 py-3 font-bold">Continua lo shopping</Link>
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  const [params] = useSearchParams();
  const oid = params.get("order_id");
  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="payment-cancelled">
      <XCircle className="mx-auto h-16 w-16 text-rose-500" />
      <h1 className="mt-6 font-display text-4xl font-bold">Pagamento annullato</h1>
      <p className="mt-3 text-stone-600">Il tuo ordine è stato salvato ed è in attesa di pagamento. Puoi riprovare quando vuoi.</p>
      <div className="mt-8 flex justify-center gap-3">
        {oid && <Link to={`/ordine/${oid}${params.get("t") ? `?t=${params.get("t")}` : ""}`} data-testid="cancel-view-order" className="rounded-full bg-amber-500 px-6 py-3 font-bold text-black">Riprova il pagamento</Link>}
        <Link to="/" className="rounded-full border border-black/15 px-6 py-3 font-bold">Home</Link>
      </div>
    </div>
  );
}
